import styled from 'styled-components';

export const TestimonialsBackground = styled.div`
    background: linear-gradient(
        108deg,
        rgba(216, 153, 6, 1) 0%,
        rgba(250, 178, 11, 1) 100%);
`;